import axios from "axios";
import React, { Component } from "react";
import Scrollspy from "react-scrollspy";
import Countdown from "react-countdown";
import { Helmet } from "react-helmet";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AudioWedding from "./components/AudioWedding";
import VolumeButton from "./components/VolumeButton";
import LoadingScreen from "./components/LoadingScreen";
import SweetAlert from "react-bootstrap-sweetalert";

import moment from "moment";
require("moment/locale/id");

class WeddingV3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wedding: {},
      undangan: {},
      muted: false,
      isReady: false,
      tanggalan: "2021-06-24",
      navText: "text-light",
      alert: null,
    };
    this.handleMute = this.handleMute.bind(this);
  }

  componentDidMount() {
    const wedUsername = this.props.match.params.username;
    axios.get(`${window.localhost}/wedding/${wedUsername}`).then((response) => {
      this.setState({
        wedding: response.data,
      });

      // Undangan
      if (this.props.match.params.permalink) {
        const wedPermalink = this.props.match.params.permalink;
        axios
          .get(`${window.localhost}/getundangan/${wedUsername}/${wedPermalink}`)
          .then((response) => {
            this.setState({
              undangan: response.data,
            });
            if (response.data) {
              setTimeout(() => this.showUndangan(), 3000);
            }
          });
      }
      setTimeout(
        () =>
          this.setState({
            isReady: true,
          }),
        2000
      );
    });
  }

  showUndangan() {
    const { undangan, wedding } = this.state;
    const tanggal = moment(wedding.tanggal, "YYYY-MM-DD").format("DD");
    const bulan = moment(wedding.tanggal, "YYYY-MM-DD").format("MMMM");
    const tahun = moment(wedding.tanggal, "YYYY-MM-DD").format("YYYY");
    const getAlert = () => (
      <SweetAlert
        title=""
        confirmBtnText="Close"
        confirmBtnBsStyle="default"
        btnSize="xs"
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        focusConfirmBtn
        showCloseButton={true}
        customClass="w-md-75 w-100 pt-5 px-0"
      >
        <div
          className="bg-undangan"
          style={{
            backgroundImage: `url(/img/aset-undangan-atas.png), url(/img/aset-undangan-bawah.png)`,
          }}
        >
          <span className="display-2 font-great-vibes">
            {wedding.namesuami} & {wedding.nameistri}
          </span>
          <hr className="col-md-6 col-8 mx-auto" />
          <p className="font-poppins">Assalamu alaikum wr. wb.</p>
          <p className="font-poppins">Kepada Yth. Bapak/Ibu/Saudara/i:</p>
          <h2 className="font-libre badge bg-light text-dark px-4 fs-3">
            {undangan.fullname}
          </h2>
          <p className="col-10 mx-auto font-poppins">
            Dengan memohon rahmat & ridho Allah Swt. kami bermaksud
            menyelenggarakan akad nikah & resepsi pernikahan yang insyaAllah
            akan dilaksanakan pada:
          </p>
          <h2 className="font-libre badge bg-light text-dark px-4 fs-3">
            {tanggal} {bulan} {tahun}
          </h2>
          <p className="font-poppins">Lokasi:</p>
          <p className="col-10 bg-light rounded-1 py-2 mx-auto font-libre px-4 mt-3">
            {wedding.desclokasi}
          </p>
          <p className="col-10 mx-auto font-poppins">
            Merupakan kehormatan bagi kami apabila <u>{undangan.panggilan}</u>{" "}
            berkenan hadir di acara kami. Atas kehadiran dan doa restunya, kami
            ucapkan terima kasih.
          </p>
          <p className="font-poppins">Wassalamu alaikum wr. wb.</p>
        </div>
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  handleMute() {
    if (this.state.muted) {
      this.setState({
        muted: false,
      });
    } else {
      this.setState({
        muted: true,
      });
    }
  }

  scriptJs() {
    // NAVBAR EFFECT
    window.onscroll = function () {
      myNavbar();
    };
    function myNavbar() {
      var x = document.getElementById("myNav");
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        x.classList.add("shadow-nav");
        x.classList.add("bg-white");
        x.classList.add("text-dark");
        x.classList.remove("bg-transparent");
        x.classList.remove("text-light");
      } else {
        x.classList.remove("shadow-nav");
        x.classList.remove("bg-white");
        x.classList.remove("text-dark");
        x.classList.add("bg-transparent");
        x.classList.add("text-light");
      }
    }
    // END NAVBAR EFFECT
  }

  render() {
    const { wedding, undangan } = this.state;
    const imgpath = `${window.localhost}/img/`;
    const musicpath = `${window.localhost}/music/`;

    const tanggal = moment(wedding.tanggal, "YYYY-MM-DD").format("DD");
    const bulan = moment(wedding.tanggal, "YYYY-MM-DD").format("MMMM");
    const tahun = moment(wedding.tanggal, "YYYY-MM-DD").format("YYYY");

    const date_lengkap = moment(wedding.tanggal, "YYYY-MM-DD").format(
      "DD MMMM YYYY"
    );

    const hmin = moment(wedding.tanggal, "YYYY-MM-DD").diff(moment(), "days");

    // Random component
    const Completionist = () => <span>You are good to go!</span>;

    // Renderer callback with condition
    const renderer = ({ hours, minutes, seconds, completed }) => {
      if (completed) {
        // Render a completed state
        return <Completionist />;
      } else {
        // Render a countdown
        return (
          <div className="row row-cols-4 text-center pt-4">
            <div className="col font-poppins">
              <h3 className="text-light fs-1">{hmin}</h3>
              <p className="fs-6">Days</p>
            </div>
            <div className="col font-poppins">
              <h3 className="text-light fs-1">{hours}</h3>
              <p className="fs-6">Hours</p>
            </div>
            <div className="col font-poppins">
              <h3 className="text-light fs-1">{minutes}</h3>
              <p className="fs-6">Minutes</p>
            </div>
            <div className="col font-poppins">
              <h3 className="text-light fs-1">{seconds}</h3>
              <p className="fs-6">Seconds</p>
            </div>
          </div>
        );
      }
    };

    if (!this.state.isReady) {
      return <LoadingScreen />;
    } else {
      return (
        <div>
          <Helmet>
            <meta charSet="utf-8" />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
            <title>
              {`${wedding.namesuami}`} & {`${wedding.nameistri}`} - Wedding
              Invitation by CreatifaStudio
            </title>
            <meta
              name="description"
              content="Wedding Invitation by CreatifaStudio"
            />
          </Helmet>
          <nav
            className="navbar navbar-expand-lg text-light fixed-top bg-transparent py-3 trans-all"
            id="myNav"
          >
            <div className="container font-poppins d-flex justify-content-between">
              <div className="px-3">
                <span className="fs-4 fw-800">
                  {wedding.namesuami} & {wedding.nameistri}
                </span>
              </div>

              <button
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample"
                className="btn btn-outline-pink d-md-none d-flex"
              >
                <FontAwesomeIcon icon={faBars} />
              </button>

              <Scrollspy
                items={[
                  "section1",
                  "section2",
                  "section3",
                  "section4",
                  "section5",
                  "section6",
                ]}
                offset={0}
                currentClassName="is-active2"
                className="nav nav-pills d-md-flex d-none"
              >
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section1">
                    Home
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section2">
                    Invitation
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section3">
                    Our Story
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section4">
                    Event
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section5">
                    Contact
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section6">
                    Gallery
                  </a>
                </li>
              </Scrollspy>
            </div>
          </nav>

          <div
            className="offcanvas offcanvas-start w-75"
            tabIndex="-1"
            id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                {wedding.namesuami} & {wedding.nameistri}
              </h5>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <Scrollspy
                items={[
                  "section1",
                  "section2",
                  "section3",
                  "section4",
                  "section5",
                  "section6",
                ]}
                offset={0}
                currentClassName="is-active2"
                className="nav nav-pills d-md-none d-block"
              >
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section1">
                    Home
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section2">
                    Invitation
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section3">
                    Our Story
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section4">
                    Event
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section5">
                    Contact
                  </a>
                </li>
                <li className="nav-item nav-item-border2">
                  <a className="nav-link text-reset" href="#section6">
                    Gallery
                  </a>
                </li>
              </Scrollspy>
            </div>
          </div>

          <div id="section1" className="container-fluid overflow-hidden">
            <div className="container-fluid">
              <div className="full-screen w-100 d-flex align-items-center">
                <div className="overlay-color-black h-100">
                  <div className="full-screen w-100 d-flex align-items-center">
                    <div className="overlay-color-white"></div>
                    <div
                      style={{ zIndex: 5 }}
                      className="mx-auto text-center py-5 px-md-5 px-4 text-light"
                    >
                      <div className="d-flex align-items-center h-100">
                        <div className="row">
                          <span className="mb-4">
                            <i className="flaticon-rose-outline-variant-with-vines-and-leaves the-rose" />
                          </span>
                          <div className="row title-bawah">
                            <div className="col mx-auto">
                              <div className="white-line me-3"> </div>
                              <span className="font-poppins fw-bold ls-1">
                                THE WEDDING OF
                              </span>
                              <div className="white-line ms-3"> </div>
                            </div>
                            <h1 className="display-0 font-great-vibes mb-4">
                              {wedding.namesuami} & {wedding.nameistri}
                            </h1>
                            <div className="col-12 col-md-8 mx-auto">
                              <div className="count-down fs-4">
                                <Countdown
                                  date={date_lengkap}
                                  renderer={renderer}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="video-background">
                  <div className="video-foreground">
                    <video
                      autoPlay
                      loop
                      muted
                      style={{
                        position: "absolute",
                        width: "100%",
                        left: "50%",
                        top: "50%",
                        height: "100%",
                        objectFit: "cover",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <source
                        src="https://apicreatifa.creatifastudio.com/videos/vidwed1.mp4"
                        type="video/mp4"
                      ></source>
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="section2">
            <div className="container">
              <div className="row row-cols-md-2 row-cols-1">
                <div className="col">
                  <img
                    src={`${imgpath}/${wedding.username}/${wedding.imgslide1}`}
                    className="img-fluid border-inside-white"
                  />
                </div>
                <div className="col border-inside-dark text-center py-4 text-secondary position-relative">
                  <div className="row vertical-center">
                    <h5 className="col-md-7 font-libre fw-bold mx-auto">
                      {wedding.descheader}
                    </h5>
                    <h1 className="display-1 my-4 text-pink font-great-vibes mb-4">
                      {wedding.namesuami} & {wedding.nameistri}
                    </h1>
                    <span className="mb-4 text-shadow">
                      <i className="flaticon-rose-outline-variant-with-vines-and-leaves the-rose rose-margin" />
                    </span>
                    <div style={{ marginTop: `-8rem` }}>
                      <h5 className="font-libre fw-bold">{wedding.title2}</h5>
                      <h1 className="font-libre fw-bold text-pink">
                        {tanggal} {bulan} {tahun}
                      </h1>
                      <h5 className="col-md-8 col-12 mx-auto font-libre fw-bold mt-5">
                        {wedding.desc2}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="bg-decr-double"
            style={{
              backgroundImage: `url(https://preview.colorlib.com/theme/hookup/images/xtop-bg.jpg.pagespeed.ic.k-BtkTlNfm.webp), url(https://preview.colorlib.com/theme/hookup/images/xbottom-bg.jpg.pagespeed.ic.ZmiElPMcFS.webp)`,
            }}
            id="section3"
          >
            <div className="container wrapper">
              <div className="row text-center">
                <span className="text-shadow" style={{ marginBottom: `-8rem` }}>
                  <i className="flaticon-rose-outline-variant-with-vines-and-leaves the-rose" />
                </span>
                <h1 className="font-great-vibes display-1 my-5 text-pink">
                  Bride & Groom
                </h1>
              </div>
              <div className="row wrapper-y-sm row-cols-md-2 row-cols-1">
                <div className="col border-inside-dark mb-5">
                  <div
                    className="full-bg img-pasutri position-relative"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgsuami})`,
                      marginTop: `-3rem`,
                      zIndex: `3`,
                    }}
                  ></div>
                  <div className="row text-center px-5 pt-4 pb-5">
                    <h2 className="display-7 font-poppins fw-light">
                      {wedding.fullnamesuami}
                    </h2>
                    <p className="font-poppins text-secondary fs-5-6">
                      {wedding.descsuami}
                    </p>
                  </div>
                </div>
                <div className="col border-inside-dark mb-5">
                  <div
                    className="full-bg img-pasutri position-relative"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgistri})`,
                      marginTop: `-3rem`,
                      zIndex: `3`,
                    }}
                  ></div>
                  <div className="row text-center px-5 pt-4 pb-5">
                    <h2 className="display-7 font-poppins fw-light">
                      {wedding.fullnameistri}
                    </h2>
                    <p className="font-poppins text-secondary fs-5-6">
                      {wedding.descistri}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-light-blue" id="section4">
            <div className="container pb-5">
              <div className="row text-center">
                <span className="text-shadow" style={{ marginBottom: `-8rem` }}>
                  <i className="flaticon-rose-outline-variant-with-vines-and-leaves the-rose" />
                </span>
                <h1 className="font-great-vibes display-1 my-5 text-pink">
                  Event Details
                </h1>
              </div>
              <div className="row row-cols-md-3 row-cols-1 g-4 font-poppins">
                <div className="col">
                  <div
                    className="py-4 px-3 full-bg"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imglokasi})`,
                    }}
                  >
                    <div className="card h-100">
                      <div className="card-body text-center py-5 px-md-5 px-3">
                        <h4 className="card-title text-pink">Lokasi</h4>
                        <p className="card-text text-secondary mt-4 lh-lg">
                          {wedding.desclokasi}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div
                    className="py-4 px-3 full-bg h-100"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgakad})`,
                    }}
                  >
                    <div className="card h-100">
                      <div className="card-body text-center py-5 px-md-5 px-3">
                        <h4 className="card-title text-pink">Akad Nikah</h4>
                        <p className="card-text text-secondary mt-4 lh-lg">
                          {wedding.descakad}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div
                    className="py-4 px-3 full-bg h-100"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgresepsi})`,
                    }}
                  >
                    <div className="card h-100">
                      <div className="card-body text-center py-5 px-md-5 px-3">
                        <h4 className="card-title text-pink">Resepsi</h4>
                        <p className="card-text text-secondary mt-4 lh-lg">
                          {wedding.descresepsi}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-blue2 pb-4" id="section5">
            <div className="container pb-5">
              <div className="row row-cols-1 text-center">
                <span
                  className="text-secondary"
                  style={{ marginBottom: `-8rem` }}
                >
                  <i className="flaticon-rose-outline-variant-with-vines-and-leaves the-rose" />
                </span>
                <h1 className="font-great-vibes display-1 mt-5 mb-3 text-pink">
                  {wedding.title4}
                </h1>
                <p className="col-md-8 col-12 mx-auto text-secondary fs-4 lh-base">
                  {wedding.desc4}
                </p>
                <br />
                <div className="col">
                  <a
                    href={`http://api.whatsapp.com/send/?phone=${wedding.nohp}`}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-outline-pink rounded-0 px-5 py-2"
                  >
                    Contact Us!
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div id="section6">
            <div className="container-fluid px-4">
              <div className="row text-center">
                <span className="text-shadow" style={{ marginBottom: `-8rem` }}>
                  <i className="flaticon-rose-outline-variant-with-vines-and-leaves the-rose" />
                </span>
                <h1 className="font-great-vibes display-1 mt-5 mb-3 text-pink">
                  Gallery Photos
                </h1>
              </div>
              <div className="row mt-4">
                <div className="col-md-4 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgslide1})`,
                    }}
                  ></div>
                </div>
                <div className="col-md-3 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgslide2})`,
                    }}
                  ></div>
                </div>
                <div className="col-md-5 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgslide3})`,
                    }}
                  ></div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-3 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imglokasi})`,
                    }}
                  ></div>
                </div>
                <div className="col-md-5 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgakad})`,
                    }}
                  ></div>
                </div>
                <div className="col-md-4 col-12 mb-3">
                  <div
                    className="w-100 full-bg img-gallery"
                    style={{
                      background: `url(${imgpath}/${wedding.username}/${wedding.imgresepsi})`,
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <footer>
            <div className="container-fluid bg-light-blue">
              <div className="row py-4">
                <ul className="nav justify-content-center text-center">
                  <li className="nav-item nav-item-border2">
                    <a className="nav-link text-secondary" href="#section1">
                      Home
                    </a>
                  </li>
                  <li className="nav-item nav-item-border2">
                    <a className="nav-link text-secondary" href="#section2">
                      Invitation
                    </a>
                  </li>
                  <li className="nav-item nav-item-border2">
                    <a className="nav-link text-secondary" href="#section3">
                      Our Story
                    </a>
                  </li>
                  <li className="nav-item nav-item-border2">
                    <a className="nav-link text-secondary" href="#section4">
                      Event
                    </a>
                  </li>
                  <li className="nav-item nav-item-border2">
                    <a className="nav-link text-secondary" href="#section5">
                      Contact
                    </a>
                  </li>
                  <li className="nav-item nav-item-border2">
                    <a className="nav-link text-secondary" href="#section6">
                      Gallery
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <AudioWedding
              muted={this.state.muted}
              musicurl={`${musicpath}/${wedding.youtubecode}`}
            />
            <VolumeButton
              handleMute={this.handleMute}
              muted={this.state.muted}
            />
            <div className="container-fluid pt-3 pb-1 w-100 bg-white">
              <p className="text-center">
                Crafted with ❤️ by{" "}
                <a
                  href="creatifastudio.com"
                  className="text-dark text-decoration-none"
                >
                  CreatifaStudio
                </a>
              </p>
            </div>
          </footer>
          {this.state.alert}
          {this.scriptJs()}
        </div>
      );
    }
  }
}

export default WeddingV3;
